module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'ismobile': _vm.isMobile
    }
  }, [_c('page-header'), _vm._v(" "), _c('el-card', {
    staticClass: "msg-card"
  }, [_c('el-tabs', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "alert"
    }
  }, [_c('span', {
    staticClass: "header-label",
    slot: "label"
  }, [_vm._v(" 报警")])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "notice"
    }
  }, [_c('span', {
    staticClass: "header-label",
    slot: "label"
  }, [_vm._v(" 通知")])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "announcement"
    }
  }, [_c('span', {
    staticClass: "header-label",
    slot: "label"
  }, [_vm._v(" 公告")])])], 1), _vm._v(" "), _c('div', _vm._l((_vm.msgList), function(msgItem) {
    return _c('div', {
      staticClass: "msg-item"
    }, [_c('div', {
      staticStyle: {
        "align-self": "flex-start"
      }
    }, [_c('el-checkbox', {
      model: {
        value: (_vm.checked),
        callback: function($$v) {
          _vm.checked = $$v
        },
        expression: "checked"
      }
    })], 1), _vm._v(" "), _c('p', [_vm._v("这是一条长长的" + _vm._s(_vm.activeTab) + "这是一条长长的" + _vm._s(_vm.activeTab) + "这是一条长长的" + _vm._s(_vm.activeTab) + "这是一条长长的" + _vm._s(_vm.activeTab) + "这是一条长长的" + _vm._s(_vm.activeTab))]), _vm._v(" "), _c('p', [_vm._v("2011-11-05 05:11:11")])])
  })), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-bottom"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checked),
      expression: "checked"
    }],
    staticClass: "tool-bar"
  }, [_c('div', [_c('el-button', {
    attrs: {
      "size": "large",
      "type": "danger"
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "large"
    }
  }, [_vm._v("取消")])], 1)])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-384aa077"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/msgList.vue
// module id = 911
// module chunks = 1